import { render, staticRenderFns } from "./AssessmentGlobalSingleTaskModalChatNotesCard.vue?vue&type=template&id=ba583776&"
import script from "./AssessmentGlobalSingleTaskModalChatNotesCard.vue?vue&type=script&lang=js&"
export * from "./AssessmentGlobalSingleTaskModalChatNotesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports